import { DefaultBody, Text, Headline, Subhead, Caption1 } from './Text';

export {
  DefaultBody,
  Headline,
  Subhead,
  Caption1,
};

export default Text;